import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import cn from 'classnames';
import { CloseButton, GridItem, TextButton, TextField, useOverlayContext, WithInfoIcon } from 'seagull';
import IntroVideoModal from '~/components/AgreementStudioPage/AgreementStudioModal/IntroVideo/IntroVideoModal/IntroVideoModal';
import { isUrlValid } from '~/components/AgreementStudioPage/AgreementStudioModal/IntroVideo/IntroVideoModal/IntroVIdeoModal.utils';
import VideoPlayer from '~/components/VideoPlayer/VideoPlayer';
import { useLocaleKeys } from '~/i18n';
import { introVideoModel } from '~/models';
import { makeIntroVideoLink, makeIntroVideoNone } from '~/models/intro-video';
import styles from './IntroVideoField.module.scss';
const IntroVideoField = (param)=>{
    let { introVideo, onChange, className, disabled } = param;
    const { t: introVideoTexts } = useLocaleKeys('components.agreementStudio.introVideo');
    const overlayContext = useOverlayContext();
    const [videoName, setVideoName] = useState('');
    const videoLink = introVideoModel.videoUrl(introVideo) || '';
    const onIntroVideoSave = (videoName, videoLink)=>{
        setVideoName(videoName);
        onChange(makeIntroVideoLink(videoLink.trim()));
    };
    const openIntroVideoModal = async ()=>{
        await overlayContext.showModal({
            biName: 'intro_video_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (p)=>/*#__PURE__*/ _jsx(IntroVideoModal, _object_spread({
                    onSave: onIntroVideoSave,
                    videoLink: videoLink
                }, p))
        });
    };
    return /*#__PURE__*/ _jsxs(GridItem, {
        span: 12,
        className: cn(styles.firstRow, className),
        children: [
            /*#__PURE__*/ _jsxs(WithInfoIcon, {
                info: introVideoTexts.infoText(),
                children: [
                    !videoName && /*#__PURE__*/ _jsx(TextButton, {
                        testId: "add-intro-video",
                        bi: {
                            name: 'add_intro_video'
                        },
                        disabled: disabled,
                        underline: "none",
                        onClick: openIntroVideoModal,
                        children: introVideoTexts.addIntroVideoButton()
                    }),
                    isUrlValid(videoLink) && !videoName && /*#__PURE__*/ _jsx("div", {
                        style: {
                            display: 'none'
                        },
                        children: /*#__PURE__*/ _jsx(VideoPlayer, {
                            url: videoLink,
                            onReady: (param)=>{
                                let { videoName } = param;
                                setVideoName(videoName);
                            }
                        })
                    }),
                    videoName && /*#__PURE__*/ _jsx(TextField, {
                        bi: {
                            name: 'intro_video_name'
                        },
                        collapseHelperText: false,
                        mobile: {
                            renderAsCard: true
                        },
                        width: 512,
                        label: introVideoTexts.fieldLabel(),
                        testId: "intro-video-name",
                        value: videoName,
                        disabled: disabled,
                        disableSuffixPadding: true,
                        suffix: !disabled && /*#__PURE__*/ _jsx(CloseButton, {
                            testId: "intro-video-remove-video-name-button",
                            bi: {
                                name: 'remove_intro_video'
                            },
                            skin: "transparent",
                            onClick: ()=>{
                                setVideoName('');
                                onChange(makeIntroVideoNone());
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(TextButton, {
                testId: "intro-video-preview",
                bi: {
                    name: 'preview_intro_video'
                },
                onClick: openIntroVideoModal,
                disabled: disabled,
                style: {
                    visibility: videoName ? 'visible' : 'hidden'
                },
                children: "Preview"
            })
        ]
    });
};
export default IntroVideoField;
